module.exports = __webpack_public_path__ + "img/cally-gerek.b046395b.jpg";